<div [ngClass]="to?.className === 'xilo-input' ? 'form-row' : 'input-form-row'">
  <div
    #dropdownPanel
    [ngClass]="to?.className === 'xilo-input' ? 'form-item' : 'input-form-item'"
  >
  <label *ngIf="to.label">
    {{ to.label }}
    <span *ngIf="to?.required" class="required-indicator">*</span>
    <span
      *ngIf="to.showToolTip"
      mat-icon-button
      aria-label="Tooltip icon"
      [matTooltip]="to.toolTipText"
      matTooltipPosition="above"
    >
        <mat-icon>help_outline</mat-icon>
      </span>
  </label>
    <ng-container *ngIf="!linkLoading">
      <!-- CASE 1: Exact match in options, where bindLabel and bindValue work -->
      <ng-select
        *ngIf="isValueInOptions(); else fallbackSelect"
        [id]="field.key"
        class="accordion"
        [ngClass]="[
          selectClassName(to?.className),
          formControl.invalid ? 'is-required ' : '',
          formControl.invalid && formControl.touched ? ' border-red ' : '',
        ]"
        (keydown.capture)="onSelectKeyDownCapture($event)"
        [dropdownOpen]="false"
        [dropdownPosition]="handleDropdownPosition()"
        [items]="to?.options"
        [formControl]="formControl"
        [placeholder]="to?.placeholder || 'Select option'"
        [clearable]="false"
        [searchable]="true"
        [multiple]="to?.isMultipleSelect"
        bindLabel="label"
        bindValue="value"
        (change)="handleValueChange($event)"
      >
      </ng-select>
      <!-- CASE 2: Value not in options — render raw value to user -->
      <ng-template #fallbackSelect>
        <ng-select
          [id]="field.key"
          class="accordion"
          [ngClass]="[
            selectClassName(to?.className),
            formControl.invalid ? 'is-required ' : '',
            formControl.invalid && formControl.touched ? ' border-red ' : '',
          ]"
          [dropdownPosition]="handleDropdownPosition()"
          [items]="to?.options"
          [formControl]="formControl"
          [placeholder]="to?.placeholder || 'Select option'"
          [clearable]="false"
          [searchable]="true"
          [multiple]="to?.isMultipleSelect"
          (change)="handleValueChange($event)"
        >
        </ng-select>
      </ng-template>
    </ng-container>
    <div *ngIf="linkLoading" class="spinner-container">
      <div class="spinner selectClassName(to?.className)"></div>
    </div>
  </div>
</div>
